import React from "react";
import { TableColumnFilter } from "newui/components/Filters";
import { ClarificationRow } from "../ClarificationRow";
import { ClarificationEmptyState } from "../../ClarificationEmptyState";
import { useClarificationsRegisterContext } from "./ClarificationsRegisterContext";

export const ClarificationsRegisterTable: React.FC = () => {
  const { data, filters, selection, modals, props } = useClarificationsRegisterContext();
  const { selectableItems, suppliers, availableStatuses, unreadCounts, editClarification } = data;
  const { filteredClarifications, supplierFilters, statusFilters, setSupplierFilters, setStatusFilters } = filters;
  const { selectedIds, handleToggleSelection } = selection;
  const { handleRowClick, handleOpenChat, handleOpenEditModal, handleOpenViewModal, handleDelete, setCopyingClarification, handleSupplierNameClick, openSupplierOnClick } = modals;
  const { isClientView, rfxId, rfxSubmissionId } = props;

  if (filteredClarifications.length === 0) {
    return <ClarificationEmptyState isClientView={isClientView} />;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            {(rfxSubmissionId || rfxId) && selectableItems.length > 0 && (
              <th className="w-10 px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              </th>
            )}
            <th className="w-10 px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Ref
            </th>
            {isClientView && !rfxSubmissionId && suppliers.length > 0 && (
              <th className="border-b border-neutral-300 px-4 py-2">
                <TableColumnFilter
                  label="SUPPLIER"
                  className="py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                  options={suppliers.map((s) => ({
                    value: s.id,
                    label: s.name,
                  }))}
                  value={supplierFilters}
                  onChange={setSupplierFilters}
                  isMulti
                />
              </th>
            )}
            <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 whitespace-nowrap">
              Type
            </th>
            <th className="border-b border-neutral-300 px-4 py-2 text-center whitespace-nowrap">
              <TableColumnFilter
                label="STATUS"
                className="py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                options={availableStatuses}
                value={statusFilters}
                onChange={setStatusFilters}
                isMulti
              />
            </th>
            <th className="w-[300px] px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Clarification
            </th>
            <th className="w-[200px] px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Relates To
            </th>
            <th className="w-[300px] px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
              Response
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500 whitespace-nowrap">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {filteredClarifications.map((clarification) => (
            <ClarificationRow
              key={clarification.id}
              clarification={clarification}
              hasSelectableItems={Boolean(rfxSubmissionId || rfxId) && selectableItems?.length > 0}
              isClientView={isClientView}
              isSelected={selectedIds.includes(clarification.id)}
              showSupplierColumn={isClientView && suppliers.length > 0 && !rfxSubmissionId}
              onRowClick={() => handleRowClick(clarification)}
              onOpenChat={handleOpenChat}
              onToggleSelect={() => handleToggleSelection(clarification.id)}
              onEdit={handleOpenEditModal}
              onView={handleOpenViewModal}
              onDelete={handleDelete}
              onCopyToSuppliers={isClientView && rfxId ? setCopyingClarification : undefined}
              onInlineEdit={isClientView ? editClarification : undefined}
              onSupplierNameClick={openSupplierOnClick ? handleSupplierNameClick : undefined}
              unreadCount={unreadCounts.get(clarification.id) || 0}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
